import React from "react";
import classNames from "classnames";

import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
//import Button from "reactstrap";

/**
 *  @property {Users_Object} state
 *  @property {object} model
 *  @property {Users_Properties} model.properties
 *  @property {Users_Is} model.is
 *  @property {Users_Has} model.has
 */
export default class TwoStepObject extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Users._name);

		this.handleProcess = this.handleProcess.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	/**
	 * @param prevProps
	 * @param {Users_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		/** @type {Users_Object|Readonly<S>} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.name_first + " " + object.name_last);
		}
	}

	/**
	 * Override to add custom validations in Objects
	 * STEP: Add Function
	 * STEP: Bind to THIS in constructor
	 *
	 * @param event
	 * @param {string|null} requestOverride
	 * @returns {boolean|*}
	 */
	handleProcess(event, requestOverride) {
		let result = super.handleProcess(event, requestOverride);

		// noinspection JSValidateTypes
		/** @type {Users_Object|Readonly<S>} object */
		let object = this.state;

		// noinspection JSIncompatibleTypesComparison
		if (object.pkey && object.password_new !== '' && object.password_new !== object.password_repeat) {
			this.setState({
				'password_repeat_error': 'Passwords must match'
			});
			result = false;
		}

		if (!object.pkey && object.password !== object.password_repeat) {
			this.setState({
				'password_repeat_error': 'Passwords must match'
			});
			result = false;
		}

		return result;
	}

	async handleSubmit(event, suppressToast = false) {
		await super.handleSubmit(event, suppressToast);
		this.setState({
			password: '',
			password_new: '',
			password_repeat: ''
		})
	}

	form = () => {
		let {properties} = this.model;
		/** @type {Users_Object|Readonly<S>} object */
		let object = this.state;
		let {loading} = this.state;
		return (
			<div>
				<fieldset>
					<div className={"row"}>
						<div className={"col-md-6 offset-3"}>

							<h4 style={{textAlign:'center'}}>Two Step Authentication is mandatory for all Admin User Accounts</h4>
							<h4 className="section-title">Two Step Authentication</h4>
							<div className="form-group">

								{/*< Button size={"sm"} color="danger">*/}
								{/*	<i className="fa fa-check"/>&nbsp;&nbsp;Remove Two Step Authentication*/}
								{/*</Button>*/}


							</div>

						</div>
					</div>
				</fieldset>
				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}

}